import { render, staticRenderFns } from "./ArgesGaleriasLista.vue?vue&type=template&id=0e61cba8&scoped=true&"
import script from "./ArgesGaleriasLista.vue?vue&type=script&lang=ts&"
export * from "./ArgesGaleriasLista.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesGaleriasLista.vue?vue&type=style&index=0&id=0e61cba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61cba8",
  null
  
)

export default component.exports